import React from "react";
const paths = {
  arrow: "M5 3l14 9-7 1-3 7z",
  hand: "M8 12V5a2 2 0 014 0v6-8a2 2 0 014 0v8-5a2 2 0 014 0v10c0 4-3 6-7 6-3 0-5-2-7-5l-3-4c-1-2 1-4 3-2l2 2",
  text: "M4 5V3h16v2M12 3v18M8 21h8",
  layers: "M12 3L2 8l10 5 10-5zM2 13l10 5 10-5M2 18l10 5 10-5",
  pages: "M6 3h12v17H6zM3 7v16h12",
  image: "M3 3h18v18H3zM3 17l6-7 5 6 3-3 4 4M15 7h.01",
  shapes: "M3 3h9v9H3zM17 12a5 5 0 100 10 5 5 0 000-10",
  styles:
    "M12 3a9 9 0 100 18h2a2 2 0 000-4h-1a2 2 0 010-4h4a4 4 0 004-4c0-4-5-6-9-6zM7 8h.01M12 6h.01M17 8h.01M5 13h.01",
  undo: "M4 4v6h6M4 10c4-9 16-6 16 2a7 7 0 01-7 7",
  redo: "M20 4v6h-6M20 10C16 1 4 4 4 12a7 7 0 007 7",
  plus: "M12 5v14M5 12h14",
  minus: "M5 12h14",
  close: "M5 5l14 14M19 5L5 19",
  back: "M14 5l-7 7 7 7",
  export: "M12 3v12M7 10l5 5 5-5M4 16v5h16v-5",
  eye: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7zM15 12a3 3 0 11-6 0 3 3 0 016 0",
  lock: "M5 10h14v11H5zM8 10V6a4 4 0 018 0v4",
  unlock: "M5 10h14v11H5zM8 10V6a4 4 0 018 0",
  duplicate: "M8 8h13v13H8zM3 16V3h13",
  trash: "M4 6h16M9 6V3h6v3M6 6l1 15h10l1-15M10 10v7M14 10v7",
  check: "M5 12l4 4L20 5",
  chevron: "M8 4l8 8-8 8",
  grid: "M3 3h18v18H3zM9 3v18M15 3v18M3 9h18M3 15h18",
  fit: "M9 3H3v6M15 3h6v6M3 15v6h6M21 15v6h-6",
  left: "M4 3v18M7 6h13v4H7zM7 14h8v4H7z",
  center: "M12 2v20M4 5h16v4H4zM7 14h10v4H7z",
  right: "M20 3v18M4 6h13v4H4zM9 14h8v4H9z",
  top: "M3 4h18M6 7h4v13H6zM14 7h4v8h-4z",
  middle: "M2 12h20M5 4h4v16H5zM14 7h4v10h-4z",
  bottom: "M3 20h18M6 4h4v13H6zM14 9h4v8h-4z",
  link: "M10 14l4-4M8 16l-2 2a4 4 0 01-6-6l5-5a4 4 0 016 0M16 8l2-2a4 4 0 016 6l-5 5a4 4 0 01-6 0",
  up: "M5 14l7-7 7 7",
  down: "M5 10l7 7 7-7",
  help: "M9 8a3 3 0 116 0c0 2-3 2-3 5M12 17h.01M22 12a10 10 0 11-20 0 10 10 0 0120 0",
  save: "M4 3h13l4 4v14H3V3zM7 3v6h10V3M7 21v-8h10v8",
  warning: "M12 3L1 21h22zM12 9v5M12 17h.01",
  search: "M16 16l5 5M18 10a8 8 0 11-16 0 8 8 0 0116 0",
};
export function Icon({ name, size = 18 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.55"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={paths[name] || paths.shapes} />
    </svg>
  );
}
export function Button({
  icon,
  children,
  title,
  active,
  className = "",
  ...props
}) {
  return (
    <button
      type="button"
      className={`ms-button ${active ? "is-active" : ""} ${className}`}
      title={title}
      aria-label={
        title || (typeof children === "string" ? children : undefined)
      }
      {...props}
    >
      {icon && <Icon name={icon} />}
      {children}
    </button>
  );
}
export function Field({ label, children, className = "", source }) {
  const field = (
    <label className={`ms-field ${className}`}>
      <span>{label}</span>
      {children}
    </label>
  );
  if (!source) return field;
  // Where the value comes from (element, named style, role) with a reset.
  return (
    <div className="ms-field-with-source">
      {field}
      <span className={`ms-value-source is-${source.level}`}>
        {source.label}
        {source.onReset && <button type="button" onClick={source.onReset} aria-label={`Reset ${label} to ${source.inherits}`} title={`Use the ${source.inherits} value`}>↺</button>}
      </span>
    </div>
  );
}
export function NumberField({
  label,
  value,
  onChange,
  min = -9999,
  max = 9999,
  step = 1,
  mixed = false,
  source,
}) {
  return (
    <Field label={label} source={source}>
      <input
        type="number"
        placeholder={mixed ? "Mixed" : undefined}
        title={mixed ? "Selected elements have different values" : undefined}
        value={!mixed && Number.isFinite(value) ? Math.round(value * 100) / 100 : ""}
        min={min}
        max={max}
        step={step}
        onChange={(e) => {
          if (e.target.value !== "" && Number.isFinite(+e.target.value))
            onChange(Math.min(max, Math.max(min, +e.target.value)));
        }}
      />
    </Field>
  );
}
export function PanelSection({ title, children, aside }) {
  return (
    <section className="ms-panel-section">
      <div className="ms-section-label">
        <h3>{title}</h3>
        {aside}
      </div>
      {children}
    </section>
  );
}
export function ColorField({ label, value, onChange }) {
  return (
    <Field label={label}>
      <span className="ms-color-input">
        <input
          type="color"
          value={/^#[0-9a-f]{6}$/i.test(value) ? value : "#382725"}
          onChange={(e) => onChange(e.target.value)}
        />
        <span>{value}</span>
      </span>
    </Field>
  );
}
